export default {
  message: {
    "strid1": "Permohonan Lesen Kejohanan Utama",
    "strid2": "Emel",
    "strid3": "Kod pengesahan emel",
    "strid4": "Nama kejohanan",
    "strid5": "Pengenalan ringkas mengenai Kejohanan",
    "strid6": "Masa mula Kejohanan",
    "strid7": "Masa tamat Kejohanan",
    "strid8": "Kejohanan ini diadakan secara dalam talian atau luar talian",
    "strid9": "Dalam Talian",
    "strid10": "Luar Talian",
    "strid11": "Termasuk fasa dalam talian dan luar talian",
    "strid12": "Maklumat hubungan lain",
    "strid14": "Sila tinggalkan maklumat hubungan anda (WhatsApp/Instagram/Facebook/Emel, dan lain-lain).",
    "strid16": "Nama anda",
    "strid17": "Penganjur",
    "strid18": "Pelaksana",
    "strid19": "Lain-lain",
    "strid20": "Serah",
    "strid21": "Kembali",
    "strid23": "Hantar",
    "strid24": "Cari",
    "strid25": "Sila sahkan alamat emel anda dengan kod pengesahan {}",
    "strid26": "Ini adalah mesej automatik, mohon jangan balas. Anda menerima emel ini kerana anda telah mengemukakan permohonan di laman web permohonan Kejohanan Pihak Ketiga kami.",
    "strid27": "Sila masukkan emel pemohon untuk mencari",
    "strid28": "Kod pengesahan emel",

    "strid29": "Sila baca Terma dan Syarat berikut",
    "strid30": "Seterusnya",
    "strid31": `Saya telah membaca dan bersetuju dengan Terma dan Syarat di atas`,
    "strid32": "Menunggu",
    "strid33": "Diluluskan",
    "strid34": "Gagal",
    "strid35": "Tarikh permohonan",
    "strid36": "Nama kejohanan",
    "strid37": "Tarikh kejohanan",
    "strid38": "Status",
    "strid39": "Permohonan anda telah berjaya diserahkan",
    "strid40": "Anda juga boleh",
    "strid41": "Menggunakan Alat Kejohanan untuk mengumpulkan pemain",
    "strid42": "Soalan Lazim",
    "strid43": "Kembali",
    "strid44": "Kod pengesahan telah dihantar",
    "strid45": `Soalan Lazim:
    1. Soalan: Adakah saya perlukan lesen untuk menganjurkan sebuah kejohanan?
    Jawapan: Ya, anda perlu memohon lesen untuk menganjurkan kejohanan komuniti. Ini bertujuan untuk memastikan pengalaman yang lebih baik bagi anda dan para peserta. Walau bagaimanapun, jika hadiah terkumpul bagi kejohanan anda kurang daripada 5,000 USD, anda boleh mendapatkan lesen secara automatik selepas mengesahkan bahawa anda telah membaca Terma dan Syarat.
    
    2. Soalan: Adakah terdapat peraturan untuk hadiah terkumpul untuk kejohanan komuniti?
    Jawapan: Ya, jika hadiah terkumpul anda melebihi 5,000 USD, anda perlu mengemukakan permohonan di laman web. Pada masa yang sama, anda akan mendapatkan lebih banyak sumber, termasuk server eksklusif dengan semua wira dan Emblem dibuka, logo dan sijil yang diluluskan, serta potensi untuk dipromosikan di media sosial rasmi.
    
    3. Soalan: Bolehkah kejohanan komuniti saya ditaja oleh penaja?
    Jawapan: Ya, boleh, tetapi kami mempunyai peraturan khusus untuk penaja. Sila rujuk kepada "Terma dan Syarat" untuk butiran.
    
    4. Soalan: Jika jadual acara saya bercanggah dengan acara e-sukan utama MLBB, adakah saya masih berpeluang untuk mendapatkan lesen?
    Jawapan: Jika hadiah terkumpul kejohanan anda kurang daripada 5,000 USD, kami tidak akan memaksa anda untuk menukar jadual. Walau bagaimanapun, jika hadiah terkumpul kejohanan anda melebihi 5,000 USD, sememangnya terdapat risiko untuk tidak memperoleh lesen rasmi. Kami masih menggalakkan anda untuk mengelakkan konflik penjadualan dengan acara e-sukan utama MLBB.
    
    5. Soalan: Apakah yang akan berlaku jika saya menganjurkan kejohanan tanpa lesen?
    Jawapan: Anda berisiko untuk ditamatkan kejohanan komuniti anda, yang merupakan pengalaman negatif untuk anda dan peserta. Jika hadiah terkumpul anda kurang daripada 5,000 USD, pastikan anda membaca "Terma dan Syarat" dengan teliti. Jika hadiah terkumpul anda melebihi 5,000 USD, pastikan anda mendapatkan lesen rasmi sebelum menganjurkan kejohanan.`,
    "strid46": "Pelesenan Kejohanan Utama Pihak Ketiga",
    "strid47":"Sejarah",
    "strid48":"Soalan Lazim",
    "strid49":"Menu utama",
    "strid50":"Application History",
    "strid51":"Pilih Rantau",
    "strid52":"WhatsApp/Instagram/Facebook/Emel, dan lain-lain",
    "strid53":"Peranan Anda",
    "strid54":"Indonesia",
    "strid55":"Filipina",
    "strid56":"Malaysia",
    "strid57":"Brazil",
    "strid58":"Singapura",
    "strid59":"Myanmar",
    "strid60":"Kemboja",
    "strid61":"Rusia dan negara-negara CIS yang lain",
    "strid62":"Türkiye",
    "strid63":"LATAM (Sepanyol)",
    "strid64":"Timur Tengah dan Afrika Utara",
    "strid65":"Amerika Utara",
    "strid66":"Eropah",
    "strid67":"Serantau",
    "strid68":"Lain-lain",
    "strid69":`
    Peraturan Am untuk Perlesenan Kejohanan oleh Pihak Ketiga "Mobile Legends: Bang Bang"<br>
    
    1. Ringkasan
    <br>
    Keizinan / Kebenaran ini digunakan untuk syarikat / organisasi / individu (selepas ini secara kolektif dirujuk sebagai "Anda") yang merancang untuk menjadi tuan rumah dan menganjurkan kejohanan pihak ketiga "Mobile Legends: Bang Bang"; jika anda mematuhi semua peruntukan Kebenaran ini dan bersedia untuk mematuhi semua keperluan Kebenaran ini, Kebenaran ini (yang merupakan Perjanjian undang-undang yang mengikat antara Moonton dan anda) boleh digunakan untuk menganjurkan dan menganjurkan acara / kejohanan pihak ketiga ( "Kejohanan").
    
    Anda mengakui dan bersetuju untuk:<br>
    
    1) Shanghai Moonton Technology Co., Ltd. dan gabungannya (selepas ini secara kolektif dirujuk sebagai "Moonton") ialah pemilik logo Moonton, tanda dagangan, "Mobile Legends: Bang Bang" dan semua maklumat dalam permainan (termasuk tetapi tidak terhad kepada watak, skin, muzik, antara muka, imej, peta dan item, dll.) ("selepas ini secara kolektif dirujuk sebagai IP Moonton");
    <br>
    2) Apabila anda menggunakan IP Moonton, sama ada digunakan secara keseluruhan atau sebahagian, anda bersetuju untuk tidak menyebabkan gangguan atau kerosakan pada IP Moonton dalam apa jua cara;
    <br>
    3) Tanpa kebenaran bertulis daripada Moonton, anda tidak dibenarkan menggunakan IP Moonton dalam apa-apa selain daripada Kejohanan ini, dan anda tidak boleh mendaftar harta intelek yang serupa atau sama dengan IP Moonton. Anda mesti menggunakan nama berkaitan IP Moonton sebagai kata kunci untuk carian Internet;
    <br>
    4) Kecuali hak terhad untuk menggunakan IP Moonton seperti yang dibenarkan oleh Kebenaran ini, Moonton tidak lagi memberikan sebarang hak lain, sama ada secara nyata atau tersirat.
    <br>
    <br>
    2. Nota Khas
    <br>
    Kebenaran hanya akan berkuat kuasa apabila Kejohanan memenuhi syarat berikut dan anda bersetuju dan menerima semua terma dan syarat dalam Perjanjian ini.
    
    Hadiah terkumpul minimum ialah USD 5000 atau bersamaan dengan IDR 70,000,000 (tujuh puluh juta rupiah)
    <br>
    <br>
     
    
    3. Peraturan Am
    <br>
    3.1. Nama Kejohanan
    <br>
    3.1.1. Perkataan "Liga" atau "Liga" tidak boleh digunakan dalam nama kejohanan / nama acara / nama penganjur.
    <br>
    3.1.2. Anda tidak boleh mempunyai nama yang sama atau serupa dengan acara / kejohanan rasmi Moonton, termasuk tetapi tidak terhad kepada Liga Profesional Mobile Legends: Bang Bang (MPL), Liga Pembangunan Mobile Legends: Bang Bang (MDL), Liga Profesional Jemputan Mobile Legends: Bang Bang (MPLI), Piala Asia Tenggara Mobile Legends: Bang Bang (MSC), Kejohanan Dunia Mobile Legends: Bang Bang (M1, M2, M3) dll.
    <br>
    3.1.3. Perkataan yang (1) membahayakan keselamatan negara, mendedahkan rahsia negara, menumbangkan kuasa negara, atau menjejaskan perpaduan negara; (2) membahayakan kehormatan dan kepentingan negara, merosakkan kepentingan awam atau menyebarkan kebencian etnik; (3) mengandungi kutukan atau penghinaan, termasuk perkataan yang berpotensi menyinggung perasaan orang lain, perkataan yang merosakkan nama baik orang lain, perkataan lucah atau kebencian atau perkataan lain yang mengganggu; (4) berkaitan dengan lucah, lucah, perjudian, dadah terlarang, keganasan atau aktiviti jenayah; (5) mempromosikan aplikasi atau permainan pihak ketiga; (6) ialah nama tidak berlesen yang hak ciptanya dipegang oleh individu atau organisasi lain yang mungkin tidak terkandung dalam nama Kejohanan;
    <br>
     
    
    3. 2. Organisasi Kejohanan
    <br>
    3.2.1. Melainkan anda telah mendapat kebenaran daripada Moonton, anda tidak boleh menyertai permainan Mudah Alih MOBA yang lain selain daripada "Mobile Legends: Bang Bang" dalam Kejohanan.
    <br>
    3.2.2. Semasa Liga Profesional Mobile Legends: Bang Bang dan Liga Pembangunan Mobile Legends: Bang Bang, anda tidak boleh melibatkan pasukan dan pemain profesional yang aktif untuk mengambil bahagian dalam apa-apa keadaan.
    <br>
    3.2.3. Syarikat atau organisasi yang menawarkan produk atau perkhidmatan yang Moonton anggap sebagai merugikan kepada MPL atau bersaing secara langsung dengan permainan mudah alih Mobile Legends: Bang Bang tidak layak menjadi hos Kejohanan.
    <br>
    3.2.4. Anda mesti menjelaskan bahawa Kejohanan ini disokong oleh E-projek dan bukannya mendakwa bahawa Kejohanan ini ditaja atau dihoskan oleh Moonton. Logo "Moonton" tidak boleh dipaparkan di mana-mana semasa Kejohanan.
    <br>
    3.2.5. Di bawah syarat mematuhi semua undang-undang dan peraturan semasa (termasuk keperluan kediaman untuk kelayakan), jika pemain atau pasukan perlu membayar yuran pendaftaran sebelum mengambil bahagian dalam Kejohanan, jumlah ganjaran keseluruhan mestilah lebih besar daripada atau sama dengan yuran pendaftaran yang dikutip.
    <br>
    3.2.6. Anda dilarang menghantar perkara yang akan merosakkan imej atau kepentingan Moonton dan Mobile Legends: Bang Bang.
    <br>
    3.2.7. Kejohanan mesti bersifat tidak rasmi. Anda bertanggungjawab terhadap sebarang masalah yang timbul. Moonton tidak akan bertanggungjawab.
    <br>
    3.2.8. Jadual Kejohanan perlu mengelak daripada berlanggar dengan jadual mana-mana Kejohanan rasmi di kawasan tuan rumah dan jadual mana-mana Kejohanan rasmi di wilayah mana-mana pasukan yang mengambil bahagian. Jika selepas kelulusan Kejohanan, Moonton mengaturkan Kejohanan rasmi baharu di kawasan tersebut, anda perlu menukar jadual dengan sewajarnya. Jika tidak, Moonton akan membatalkan Kebenaran Kejohanan dan meminta untuk menghentikan Kejohanan.
    <br>
    3.2.9. Skala Kejohanan mestilah selaras dengan pelan yang ditetapkan oleh Moonton.
    <br>
    3.2.10. Anda mesti memberi pemain bonus atau hadiah lain seperti yang dijanjikan.
    <br>
    3.2.11. Anda tidak dibenarkan menyiarkan Kejohanan di TV.
    <br>
    3.2.12. Anda bersetuju untuk memindahkan video atau rakaman video yang berkaitan dengan Kejohanan secara kekal dan tidak boleh ditarik balik kepada Moonton atau ahli gabungannya tanpa menerima bayaran tambahan, serta memberikan hak dan faedah global Moonton atau ahli gabungannya (termasuk tetapi tidak terhad kepada pemilikan dan hak harta intelek, dll.) .
    <br>
    3.2.13. Moonton, sebagai pemilik video atau rakaman video Kejohanan, berhak untuk menyiarkan atau memainkan semula kandungan yang disebutkan di atas, dan boleh memindahkan hak tersebut kepada pihak ketiga; Moonton juga berhak untuk mengubah kandungan video dan menerbitkannya dalam apa jua bentuk atau untuk tujuan komersial.
    <br>
    3.2.14. Anda menjamin kepada Moonton bahawa sebarang video atau rakaman video Kejohanan tidak akan melanggar hak sesiapa, atau melanggar undang-undang dan peraturan tempatan, dan tidak akan mengandungi sebarang kandungan yang merosakkan reputasi atau melibatkan fitnah.
    <br>
    3.2.15. Anda dan pasukan yang mengambil bahagian tidak boleh membeli atau menjual slot atau menyertai Kejohanan sebagai francais.
    <br>
    3.3. Pendapatan dan Kos
    <br>
    3.3.1. Syarikat yang terlibat dalam penjualan atau promosi produk atau perkhidmatan yang berikut tidak dibenarkan menjadi penaja Kejohanan:
    <br>
    -Pornografi (atau kandungan dewasa yang sangat eksplisit);
    <br>
    -Alkohol, ganja dan dadah yang dilarang;
    <br>
    -Tembakau atau syarikat yang berkaitan dengannya (seperti PRO, Super atau LA Zone, dll.);
    <br>
    -Senjata api;
    <br>
    -Organisasi yang terlibat dalam perjudian;
    <br>
    3.3.2 Syarikat atau organisasi yang menawarkan produk atau perkhidmatan yang Moonton anggap sebagai merugikan kepada MPL atau bersaing secara langsung dengan permainan mudah alih Mobile Legends: Bang Bang.
    <br>
    3.3.3. Kejohanan ini tidak akan melibatkan sebarang bentuk perjudian (termasuk loteri dan pertaruhan kompetitif secara maya).
    <br>
    3.3.4. Acara ini tidak ditaja / disokong oleh mana-mana parti politik tertentu atau organisasi yang berkait rapat dengan kepentingan politik / perkauman / etnik / agama tertentu.
    <br>
    3.3.5. Acara ini mematuhi peraturan tempatan (terutamanya yang berkaitan dengan protokol kesihatan).
    <br>
    3.3.6. Jika anda ingin melakukan aktiviti pendanaan awam untuk Kejohanan, anda mesti menjamin bahawa Kejohanan dan aktiviti pendanaan awam tidak mempunyai kaitan dengan Moonton. Segala faedah yang diperoleh melalui pendanaan awam tersebut hendaklah digunakan sepenuhnya untuk Kejohanan. Anda tidak dibenarkan menyimpan hasil pendanaan awam sebagai keuntungan peribadi.
    <br>
    3.3.7. Anda tidak boleh membuat atau menjual sebarang barangan yang mengandungi Moonton dan jenama atau elemen berkaitan atas nama Kejohanan.
    <br>
    3.3.8. Anda tidak boleh menggunakan organisasi Kejohanan dan acara berkaitan dengan Kejohanan untuk tujuan keuntungan, dan tidak dibenarkan memperoleh pendapatan yang menguntungkan daripadanya.
    <br>
    <br>
    4. Lain-lain
    <br>
    4.1. Jika anda ingin menganjurkan Kejohanan di bawah terma Kebenaran ini, anda wajib mematuhi semua terma dan syarat yang dinyatakan di sini. Sekiranya anda menganjurkan Kejohanan tanpa memperoleh Kebenaran, anda dianggap telah bersetuju dengan terma dan syarat yang terkandung dalam Perjanjian Kebenaran ini.
    <br>
    4.2. Anda bersetuju bahawa Moonton berhak untuk menyemak buku dan rekod anda bagi memastikan pematuhan terhadap terma Perjanjian ini.
    <br>
    4.3. Sekiranya terdapat pertikaian antara anda dan Moonton, kami akan berusaha menyelesaikannya melalui rundingan selama 30 hari bersama pihak yang terlibat. Jika rundingan gagal, pertikaian tersebut akan ditentukan oleh undang-undang Singapura dan perlu dirujuk kepada Pusat Timbang Tara Antarabangsa Singapura untuk penyelesaian.
    <br>
    4.4. Kejohanan mesti mematuhi semua undang-undang dan peraturan yang berkenaan, serta dasar penyedia perkhidmatan pihak lain yang mungkin anda gunakan; Sekiranya berlaku apa-apa semasa Kejohanan anda, termasuk kegagalan anda untuk mematuhi terma dan syarat Kebenaran ini, menyebabkan tuntutan atau saman dihantar oleh pihak ketiga, anda bertanggungjawab sepenuhnya dan bersetuju untuk memberi pampasan kepada Moonton.
    <br>
    4.5. Keperluan Kebenaran Kejohanan hanya terpakai di rantau yang anda ditugaskan. Penafsiran terakhir bagi Peraturan Am ini adalah dipegang oleh Moonton. Untuk perkara-perkara yang tidak tercakup, penafsiran rasmi Kejohanan akan digunakan. Moonton berhak untuk melaraskan dan menerbitkan peraturan berdasarkan situasi sebenar tanpa notis kepada anda.
    <br>
    4.6. Moonton berhak untuk membatalkan Kejohanan dalam apa jua keadaan, dan tidak akan bertanggungjawab terhadap kerugian anda.`
    ,
    "strid70":"Lain-lain",
    "strid71":"Kod pengesahan telah dihantar ke e-mel anda {emails}. Sila periksa.",
    "strid72":"Jumlah hadiah terkumpul pertandingan adalah (sila tukar kepada USD)",
    "strid73":`*Tidak perlu memohon lesen berdasarkan hadiah terkumpul semasa. Anda boleh menggunakan <a href="https://play.mobilelegends.com/match/#/" target="_blank">Alat Pertandingan</a> untuk mencipta pertandingan secara terus dan ia akan mendapat lesen secara automatik.`,
  }
}

